import React, { useRef, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { Menu, X, ChevronDown } from 'lucide-react';

gsap.registerPlugin(useGSAP);

export default function Header() {
  const headerRef = useRef();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu on route change
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header 
      ref={headerRef} 
      className={`consulting-header ${isScrolled ? 'header-scrolled' : ''}`}
    >
      <div className="header-content">
        <Link to="/" className="logo">
          IronQuill
        </Link>
        
        <nav className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          
          <Link 
            to="/about" 
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
          >
            About
          </Link>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <Link 
              to="/services" 
              className={`nav-link ${location.pathname.includes('/services') ? 'active' : ''}`}
            >
              Services <ChevronDown size={16} style={{ display: 'inline', marginLeft: '4px' }} />
            </Link>
            
            {servicesOpen && (
              <div className="dropdown-menu">
                <Link to="/services/proposal-development" className="dropdown-item">
                  Proposal Development
                </Link>
                <Link to="/services/capture-support" className="dropdown-item">
                  Capture Support
                </Link>
                <Link to="/services/proposal-management" className="dropdown-item">
                  Proposal Management
                </Link>
                <Link to="/services/proposal-design" className="dropdown-item">
                  Proposal Design
                </Link>
              </div>
            )}
          </div>
          
          <Link 
            to="/process" 
            className={`nav-link ${isActive('/process') ? 'active' : ''}`}
          >
            Process
          </Link>
          
          <Link 
            to="/case-studies" 
            className={`nav-link ${isActive('/case-studies') ? 'active' : ''}`}
          >
            Case Studies
          </Link>
          
          <Link 
            to="/free-assessment" 
            className="nav-link-special"
          >
            Free Assessment
          </Link>
          
          <Link to="/contact" className="cta-button">
            Contact Us
          </Link>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
}
